import { render, staticRenderFns } from "./button.vue?vue&type=template&id=32840c7c&scoped=true&"
import script from "./button.vue?vue&type=script&lang=ts&"
export * from "./button.vue?vue&type=script&lang=ts&"
import style0 from "./button.vue?vue&type=style&index=0&id=32840c7c&lang=scss&scoped=true&"
import style1 from "./button.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32840c7c",
  null
  
)

export default component.exports